import { type PivotRowAttributes } from './generated/PivotRowAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

const RANK_COLUMN_NAME = 'bookmarks_record_positions_rank';

interface PivotRow extends PivotRowAttributes {}

@model
class PivotRow extends ApplicationModel {
  // Start auto-generated
  static typename: 'PivotRow' = 'PivotRow';
  get typename(): 'PivotRow' {
    return 'PivotRow';
  }

  static fields = {
    record: attr.belongsTo({
      readable: true,
      typename: ['Epic', 'Feature', 'Idea', 'Initiative'],
    }),
    cells: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  get rankCell() {
    return this.cells.find(cell => cell.pivotColumn.key === RANK_COLUMN_NAME);
  }

  get placeholder() {
    return false;
  }
}

export { RANK_COLUMN_NAME };
export default PivotRow;
